import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-32fcd4ca"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "view-content",
  id: "core-product-capabilities"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "核心产品能力", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "构建用户运营、健康管理和商业变现为一体的数字化解决方案", -1));
const _hoisted_4 = {
  class: "contentBox"
};
const _hoisted_5 = {
  class: "imgWrap"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["onMouseenter"];
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "intro"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OPTIONS, (part, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "partWrap",
      key: i
    }, [_createElementVNode("h4", null, _toDisplayString(part.title), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(part.items, (item, j) => {
      return _openBlock(), _createElementBlock("img", {
        key: j,
        src: item.img,
        width: "660",
        height: "480",
        class: _normalizeClass({
          active: _ctx.activeList[i] === j
        })
      }, null, 10, _hoisted_6);
    }), 128))]), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(part.items, (item, j) => {
      return _openBlock(), _createElementBlock("li", {
        key: j,
        class: _normalizeClass({
          active: _ctx.activeList[i] === j
        }),
        onMouseenter: $event => _ctx.activeList[i] = j
      }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
        src: item.icons[+(_ctx.activeList[i] === j)],
        width: "28",
        height: "28"
      }, null, 8, _hoisted_9), _createElementVNode("span", null, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_10, _toDisplayString(item.intro), 1)], 42, _hoisted_7);
    }), 128))])])]);
  }), 128))]);
}